import { toast } from "react-toastify";
import defaultErrorHandler from "actions/global/default-error-handler";
import {
  requestTariffGetList,
  requestTariffAdd,
  requestTariffAddImage,
  requestTariffGetImage,
} from "./requests";

import {
  TARIFF_LOADING,
  TARIFF_ERROR,
  TARIFF_GET_LIST,
  TARIFF_RESET_LIST,
  TARIFF_ADD,
  TARIFF_ADD_IMAGE,
  TARIFF_GET_IMAGE,
} from "./constants";

export const setLoading = (status) => ({
  type: TARIFF_LOADING,
  payload: status
});

export const tariffGetList = () => dispatch => {
  dispatch(setLoading(true));
  requestTariffGetList()
    .then(response => {
      dispatch({
        type: TARIFF_GET_LIST,
        payload: response.data
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, TARIFF_ERROR));
    });
};

export const actionResetList = () => dispatch => {
  dispatch({
    type: TARIFF_RESET_LIST
  });
};

export const tariffAdd = (data, callback = false) => dispatch => {
  dispatch(setLoading(true));
  requestTariffAdd(data)
    .then(response => {
      dispatch({
        type: TARIFF_ADD,
        payload: response.data.content
      });
      if (callback) {
        callback(response.data.content);
      }
      toast("Tariff updated successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, TARIFF_ERROR));
    });
};

export const tariffAddImage = (id, img, callback) => dispatch => {
  dispatch(setLoading(true));
  requestTariffAddImage(id, img)
    .then(response => {
      dispatch({
        type: TARIFF_ADD_IMAGE,
        payload: response.data
      });
      toast("Image added successfully", {
        type: toast.TYPE.SUCCESS,
      });
      callback();
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, TARIFF_ERROR));
    });
};

export const tariffGetImage = (id) => dispatch => {
  dispatch(setLoading(true));
  requestTariffGetImage(id)
    .then(response => response.data.arrayBuffer())
    .then(buffer => {
      const blob = new Blob([buffer]);
      const url = URL.createObjectURL(blob);
      dispatch({
        type: TARIFF_GET_IMAGE,
        payload: url
      });
    })
    .catch(() => {
      dispatch(setLoading(false));
    });
};



// WEBPACK FOOTER //
// ./src/actions/chargers/tariff/actions.js